import React from 'react';
import { Card } from '@nearst/ui';

import { formatPrice } from '@utils/currency';

import styles from './StockData.module.scss';

const StockData = ({ stockItem }) => {
	const { barcode, price, currency, quantity } = stockItem;

	return (
		<Card title="Stock data" data-cy="inventory-item-stock-data">
			<div className={styles.container}>
				<span className={styles.field}>Barcode</span> <span>{barcode}</span>
				<span className={styles.field}>Price</span> <span>{formatPrice(price, currency)}</span>
				<span className={styles.field}>Quantity</span> <span>{quantity} in stock</span>
			</div>
		</Card>
	);
};

const StockDataSummary = ({ stockItem }) => {
	const { barcode, currency, priceRange, inStockTotal, inStockLocations, outOfStockLocations } = stockItem;

	return (
		<Card title="Stock data summary" data-cy="inventory-item-stock-data">
			<div className={styles.container}>
				<span className={styles.field}>Barcode</span> <span>{barcode}</span>
				<span className={styles.field}>Price</span>{' '}
				<span>
					{priceRange.min === priceRange.max
						? formatPrice(priceRange.min, currency)
						: `${formatPrice(priceRange.min, currency)} - ${formatPrice(priceRange.max, currency)}`}
				</span>
				<span className={styles.field}>Quantity</span> <span>{inStockTotal} units</span>
				<span className={styles.field}>In stock</span> <span>{inStockLocations} locations</span>
				<span className={styles.field}>Out of stock</span> <span>{outOfStockLocations} locations</span>
			</div>
		</Card>
	);
};

export { StockData, StockDataSummary };
